import firebaseErrorMessages from './firebase-error-messages';

interface FirebaseError {
  code?: string;
}

export function parseFirebaseError(error: FirebaseError): string {
  if (error && error.code) {
    const message = firebaseErrorMessages[error.code];
    return message || 'An unknown error occurred. Please try again.';
  }
  return 'An error occurred. Please try again.';
}
